import { render, staticRenderFns } from "./PortalInitialization.vue?vue&type=template&id=6f5c89f6"
import script from "./PortalInitialization.vue?vue&type=script&lang=js"
export * from "./PortalInitialization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports